<template>
    <form>
        <div class="bet-name">
            <span>{{'normal_bet' | translate }}</span>
        </div>
        <div id="bet-area" class="betting-inputs">
            <input
                v-for="index in bettingInputs"
                :key = "index"
                v-model="bettingSvc.ticket.input[index-1]"
                v-normal-bet-validator
                type="number"
                @keydown="checkChars"
                @keydown.enter.prevent = "setFocus(index)"
                @keydown.tab.prevent   = "setFocus(index)"
                @click="setFocus(index,true)"
                autocomplete="off"
                :disabled="isBettingDisabled"
            >
        </div>
    </form>
</template>

<script>
import {BettingSvc} from '../../../services/betting.service';
import {EventBus}   from '../../../utilities/event.bus';
import {GatewaySvc} from '../../../services/gateway.service';
import {GameSvc} from '../../../services/game.service';
import {NormalBetValidator} from '../../../directives/normalbet_validator';
import {TicketSvc}  from '../../../services/ticket.service';
import {invalidChars} from '../../../utilities/invalidCharsChecker';
import {translate} from '../../../filters/translate';

    let betActive = false,
        betForm,
        futureBet,
        ticket,
        systemBet;

    export default {
        name: 'NormalBet',
        directives: {
            NormalBetValidator,
        },
        filters: {
            translate,
        },

        data() {
            return {
                bettingSvc : BettingSvc.getBettingSvc(),
                gameSvc : GameSvc.getGameSvc(),
                normal_bet : 'normal_bet',
                spotNumber: GameSvc.getGameSvc().spotNumber
            }
        },

        computed: {
            bettingInputs() {
                return this.spotNumber === undefined || this.bettingSvc.type === 'system' ?
                    this.bettingSvc.maxSystemNumber : this.spotNumber;
            },
            isBettingDisabled () {
                return this.gameSvc.gameInfo.betsBlocked;
            }
        },

        mounted() {
            betForm   =  typeof document.getElementById('bet-area') === 'object' ? document.getElementById('bet-area').getElementsByTagName('input') : '';
            futureBet =  document.getElementById('future') || '';
            systemBet =  document.getElementById('system') || '';
            ticket =  TicketSvc.getTicketSvc().ticket;
            BettingSvc.getBettingSvc().clearAll();
            this.setFocus();
            this._subscribeEvents();
        },

        destroyed(){
            this.unsubscribeEvents();
        },

        methods: {
            checkChars(event) {
                invalidChars(event);
            },

            /**
             * Set focus on right input
             * @param index
             * @param clickEvent
             */

            setFocus(index, clickEvent) {
                if (!betForm || !betActive) return;

                //on bet activation set focus on first input
                if (!index) {
                    betForm[0].focus();
                    return;
                }

                //find first empty input and set focus
                for(let i = 0; i < betForm.length; i++){
                    if(betForm[i].value === betForm[index-1].value && i !== (index-1) && betForm[index-1].value){
                        betForm[index-1].focus();
                        return;
                    }
                }

                //on adding bet on betslip send event to master to set focus on payin
                if(index === 1 && !betForm[0].value && !clickEvent){
                    let ticket = TicketSvc.getTicketSvc().ticket;

                    if(ticket && ticket.bets.length){
                        GatewaySvc.getGatewaySvc().sendMessage('FocusNext',[31]);
                    }

                    return;

                }

                // if clicked inside number inputs
                if (clickEvent){

                    // if clicked on already filled value focus it
                    if (betForm[index-1].value) {
                        betForm[index-1].focus();
                        return;
                    }

                    // set focus on first empty input
                    for(let i = 0; i < betForm.length; i++){
                        if(!betForm[i].value){
                            betForm[i].focus();
                            return;
                        }
                    }
                }

                // if system bet is activated set focus on system input
                if((!betForm[index-1].value || betForm[betForm.length -1].value) &&
                    document.getElementById('system')){
                    document.getElementById('system').focus();
                    return;
                }

                // if future bet is activated set focus on future bet input
                if((!betForm[index-1].value || betForm[betForm.length -1]) &&
                    document.getElementById('future')){
                    document.getElementById('future').select();
                    return;
                }

                // create bet
                if(!betForm[index - 1].value || betForm[betForm.length - 1].value){
                    try {
                        this.bettingSvc.finalizeTicket();
                    } catch (err) {
                        return;
                    }
                    EventBus.$emit('Shop.Clear');
                    return;
                }

                betForm[index].focus();

            },

            _subscribeEvents(){

                // listen for keyboard event
                EventBus.$on('Keno.KeyboardEvent', event => {
                    if(event.key === '+'){
                        this.setFocus();
                    }
                });

                // activate bet only if iframe visible
                EventBus.$on('Slave.Shown', () => {
                    betActive = true;
                });

                // listen for future bet validation and finalize bet
                EventBus.$on('Keno.FutureBetValid', () => {
                    try {
                        this.bettingSvc.finalizeTicket();
                    } catch (err) {
                        return;
                    }
                    this.resetAll();
                });

                // clear betting service
                EventBus.$on('Shop.Clear',() => {
                   this.resetAll();
                });

                // Force computed to work properly
                EventBus.$on('Keno.SpotNumberChanged', () => {
                    this.spotNumber = this.gameSvc.spotNumber;
                });

            },

            /**
             * Reset betting service and set focus on first input
             */

            resetAll() {

                this.bettingSvc.clearAll();
                EventBus.$emit('keydown',{
                        key : '+'
                });

            },

            /**
             * Unsubscribe events
             */

            unsubscribeEvents(){

                EventBus.$off('Shop.Clear');
                EventBus.$off('Keno.KeyboardEvent');
                EventBus.$off('Keno.FutureBetValid');
                EventBus.$off('Keno.SpotNumberChanged');
                EventBus.$off('Slave.Shown');
            }
        }
    };

</script>

<style  lang="scss">
    @import '../../../assets/style/shop/betting';
</style>



// WEBPACK FOOTER //
// NormalBet.vue?d20ff3fc